<template>
  <div class="form-group">
    <label class="custom-label">{{labelDesc}}</label>
    <div class="form">
      <label style="width: 250px;">
        <input type="checkbox" v-model="separatorActive" @change="changeValue" @keyup="changeValue">
        {{ $t('ct-active') }}
      </label>
      <label v-show="separatorActive===true" class="w-100">
        {{ $t('ct-effect') }}

        <select v-model="separatorEffect" class="custom-input form-control w-100" @change="changeValue"
                @keyup="changeValue">
          <option v-for="option in optionsAll" v-bind:value="option">
            {{ $t('ct-divider-effect-'+option) }}
          </option>
        </select>

      </label>
    </div>
    <div v-show="separatorActive == true && colorCounter[separatorEffect] >= 1">
      <label class="custom-label" style="width: 100%">{{$t('ct-shape-divider-first-color')}}</label>
      <div class="form" style="display: inline-flex;width: 100%">
        <color-picker-component ref="colorPickerFirst"></color-picker-component>
      </div>

    </div>
    <div v-show="separatorActive == true && colorCounter[separatorEffect] >= 2">
      <label class="custom-label" style="width: 100%">{{$t('ct-shape-divider-second-color')}}</label>
      <div class="form" style="display: inline-flex;width: 100%">
        <color-picker-component ref="colorPickerSecond"></color-picker-component>
      </div>
    </div>
    <div v-show="separatorActive == true && colorCounter[separatorEffect] >= 3">
      <label class="custom-label" style="width: 100%">{{$t('ct-shape-divider-third-color')}}</label>
      <div class="form" style="display: inline-flex;width: 100%">
        <color-picker-component ref="colorPickerThird"></color-picker-component>
      </div>

    </div>
    <div v-show="separatorActive == true && colorCounter[separatorEffect] >= 4">
      <label class="custom-label" style="width: 100%">{{$t('ct-shape-divider-fourth-color')}}</label>
      <div class="form" style="display: inline-flex;width: 100%">
        <color-picker-component ref="colorPickerFourth"></color-picker-component>
      </div>

    </div>

    <div v-show="sizeCounter[separatorEffect] >= 1 && separatorActive===true">
      <div class="form-group">
        <div class="form">
          <label>
            <input type="checkbox" class="custom-input" v-model="custom" @change="changeValue" @keyup="changeValue">
            {{$t('ct-customize-divider')}}
          </label>
          <p class="alert-info text-center">{{$t('ct-customize-divider-helper')}}</p>
        </div>
      </div>
    </div>

    <div v-show="separatorActive == true && sizeCounter[separatorEffect] >= 1">
      <div class="form-group">
        <label class="custom-label">{{$t('ct-shape-divider-first-size')}}</label>
        <div>
          <label class="label-range-custom">
            <input type="range" class="custom-range" min="0" max="10" step="1" v-model="value1" @change="changeValue"
                   @mousemove="changeValue">
            <input type="number" class="custom-input form-control " v-model="value1" min="0" max="10" step="1"
                   @change="changeValue" @keyup="changeValue">
          </label>
        </div>
      </div>
    </div>
    <div v-show="separatorActive == true && sizeCounter[separatorEffect] >= 2">
      <div class="form-group">
        <label class="custom-label">{{$t('ct-shape-divider-second-size')}}</label>
        <div>
          <label class="label-range-custom">
            <input type="range" class="custom-range" min="0" max="10" step="1" v-model="value2" @change="changeValue"
                   @mousemove="changeValue">
            <input type="number" class="custom-input form-control " v-model="value2" min="0" max="10" step="1"
                   @change="changeValue" @keyup="changeValue">
          </label>
        </div>
      </div>
    </div>
    <div v-show="separatorActive == true && sizeCounter[separatorEffect] >= 3">
      <div class="form-group">
        <label class="custom-label">{{$t('ct-shape-divider-third-size')}}</label>
        <div>
          <label class="label-range-custom">
            <input type="range" class="custom-range" min="0" max="10" step="1" v-model="value3" @change="changeValue"
                   @mousemove="changeValue">
            <input type="number" class="custom-input form-control " v-model="value3" min="0" max="10" step="1"
                   @change="changeValue" @keyup="changeValue">
          </label>
        </div>
      </div>
    </div>
    <div v-show="separatorActive == true && sizeCounter[separatorEffect] >= 4">

      <div class="form-group">
        <label class="custom-label">{{$t('ct-shape-divider-fourth-size')}}</label>
        <div>
          <label class="label-range-custom">
            <input type="range" class="custom-range" min="0" max="10" step="1" v-model="value4" @change="changeValue"
                   @mousemove="changeValue">
            <input type="number" class="custom-input form-control " v-model="value4" min="0" max="10" step="1"
                   @change="changeValue" @keyup="changeValue">
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import ColorPickerComponent from "./Abstract/ColorPicker";

  export default {
    name: 'DividerComponent',
    components: {ColorPickerComponent},
    data() {
      return {
        element: null,
        separatorActive: false,
        separatorEffect: '',
        value1: 0,
        value2: 0,
        value3: 0,
        value4: 0,
        custom: false,
        labelDesc: 'opa',
        callback: null,
        optionsAll: [
          'waves-floating',
          'drip-up',
          'drip-down',
          'mid-arrow',
          'waves-fixed',
          'polygon',
          'polygon-up',
          'banner-lateral',
          'drops',
          'waves-lateral',
          'zigzag',
          'big-arrow',
          'clouds',
          'curve',
          'arrow-reverse',
          'pixels',
          'big-round',
          'breaker',
        ],
        colorCounter: {
          'waves-floating': 4,
          'drip-up': 3,
          'drip-down': 3,
          'mid-arrow': 3,
          'waves-fixed': 3,
          'polygon': 3,
          'polygon-up': 3,
          'banner-lateral': 3,
          'drops': 2,
          'waves-lateral': 3,
          'zigzag': 3,
          'big-arrow': 3,
          'clouds': 1,
          'curve': 3,
          'arrow-reverse': 3,
          'pixels': 3,
          'big-round': 2,
          'breaker': 3,
        },
        sizeCounter: {
          'waves-floating': 4,
          'drip-up': 2,
          'drip-down': 0,
          'mid-arrow': 3,
          'waves-fixed': 0,
          'polygon': 2,
          'polygon-up': 2,
          'banner-lateral': 2,
          'drops': 0,//?
          'waves-lateral': 2,
          'zigzag': 0,
          'big-arrow': 2,
          'clouds': 1,
          'curve': 1,
          'arrow-reverse': 1,
          'pixels': 2,
          'big-round': 2,
          'breaker': 1
        },
      }
    },
    methods: {
      changeValue() {


        this.callback();
      },
      setValues(obj) {
        this.separatorActive = obj.separatorActive;
        this.separatorEffect = obj.separatorEffect;
        this.separatorEffect = obj.separatorEffect;
        this.separatorColorsFirst = obj.separatorColorsFirst;
        this.separatorColorsSecond = obj.separatorColorsSecond;
        this.separatorColorsThird = obj.separatorColorsThird;
        this.separatorColorsFourth = obj.separatorColorsFourth;

        this.value1 = obj.separatorValueFirst;
        this.value2 = obj.separatorValueSecond;
        this.value3 = obj.separatorValueThird;
        this.value4 = obj.separatorValueFourth;

        this.custom = obj.separatorValueCustom;

        this.element = obj.element;
        this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
        this.callback = obj.callback;

        let vm = this;

        let newObjFirst = Object.assign({}, obj);
        newObjFirst.defaultValue = obj.separatorColorsFirst;
        newObjFirst.callback = (value) => {
          vm.separatorColorsFirst = value;
          vm.changeValue()
        };
        this.$refs.colorPickerFirst.setValues(newObjFirst, true);


        let newObjSecond = Object.assign({}, obj);
        newObjSecond.defaultValue = obj.separatorColorsSecond;
        newObjSecond.callback = (value) => {
          vm.separatorColorsSecond = value;
          vm.changeValue()
        };
        this.$refs.colorPickerSecond.setValues(newObjSecond, true);


        let newObjThird = Object.assign({}, obj);
        newObjThird.defaultValue = obj.separatorColorsThird;
        newObjThird.callback = (value) => {
          vm.separatorColorsThird = value;
          vm.changeValue()
        };
        this.$refs.colorPickerThird.setValues(newObjThird, true);

        let newObjFourth = Object.assign({}, obj);
        newObjFourth.defaultValue = obj.separatorColorsFourth;
        newObjFourth.callback = (value) => {
          vm.separatorColorsFourth = value;
          vm.changeValue()
        };
        this.$refs.colorPickerFourth.setValues(newObjFourth, true);
      }
    }
  }
</script>
<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/Divider.vue